import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Row = ({ label, value }) => (
  <div className="flex gap-2 text-sm">
    <span className="min-w-[120px] font-semibold text-[#475569]">{label}</span>
    <span className="text-[#172033]">{value}</span>
  </div>
);

export function AdmitCardBody({ d, compact }) {
  return (
    <div className={`admit-card border border-[#172033] ${compact ? 'p-3' : 'p-5'}`}>
      <div className="flex items-center gap-3 border-b border-[#CBD5E1] pb-2">
        <img src="/hpmi-logo.webp" alt="HPMI" className={compact ? 'h-9 w-9' : 'h-14 w-14'} />
        <div>
          <p className={`font-heading font-bold text-navy ${compact ? 'text-xs' : 'text-base'}`}>{d.school_name}</p>
          <p className={`font-semibold uppercase tracking-wide text-[#475569] ${compact ? 'text-[9px]' : 'text-xs'}`}>{d.title}</p>
        </div>
      </div>
      <div className={`mt-2 space-y-1 ${compact ? 'text-[11px]' : 'text-sm'}`}>
        <Row label="Form No.:" value={d.form_number} />
        <Row label="Name:" value={d.applicant_name} />
        <Row label="Admission Test For:" value={d.class_name} />
        <Row label="Previous School:" value={d.previous_school} />
        <Row label="2nd Language:" value={d.second_language} />
      </div>
      <div className={`mt-2 border-t border-dashed border-[#CBD5E1] pt-2 space-y-1 ${compact ? 'text-[11px]' : 'text-sm'}`}>
        <Row label="Test Date:" value={d.test_date} />
        {d.test_time && <Row label="Test Time:" value={d.test_time} />}
        {d.venue && <Row label="Venue:" value={d.venue} />}
      </div>
    </div>
  );
}

export default function AdmitCard() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/admit/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || 'Unable to load admit card.'));
  }, [token]);

  if (err) return <div className="flex min-h-screen items-center justify-center p-6 text-center text-sm text-[#B91C1C]" data-testid="admit-error">{err}</div>;
  if (!d) return <div className="flex min-h-screen items-center justify-center text-sm text-[#94A3B8]">Loading…</div>;

  return (
    <div className="mx-auto min-h-screen max-w-md bg-[#F5F7FB] p-4" data-testid="admit-card-page">
      <div className="mb-3 print:hidden">
        <button data-testid="admit-print-btn" onClick={() => window.print()} className="w-full rounded-lg bg-navy py-2.5 text-sm font-semibold text-white">Print / Save as PDF</button>
      </div>
      <div className="rounded-xl bg-white p-2 shadow-sm print:shadow-none">
        <AdmitCardBody d={d} />
      </div>
    </div>
  );
}
